"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variant = void 0;
var Variant;
(function (Variant) {
    Variant["page"] = "page";
    Variant["section"] = "section";
    Variant["component"] = "component";
    Variant["element"] = "element";
})(Variant || (exports.Variant = Variant = {}));
